
const cloudinaryBaseURL = 'https://res.cloudinary.com/dpoz8quj5/image/upload/';

export function cloudinaryURLFromImage(cloudinaryImage) {
    return `${cloudinaryBaseURL}${cloudinaryImage}`;
}

export function cloudinaryImageFromURL(cloudinaryURL) {
    if (cloudinaryURL && cloudinaryURL.indexOf(cloudinaryURL) === 0) return cloudinaryURL.substring(cloudinaryBaseURL.length);
    else return '';
}

export function cloudinaryResizeImage(cloudinaryImage, width, opt_height) {
    if (opt_height) return `${cloudinaryBaseURL}c_scale,h_${opt_height},w_${width}/${cloudinaryImage}`;
    else return `${cloudinaryBaseURL}c_scale,w_${width}/${cloudinaryImage}`;
}

export function cloudinaryResizeURL(cloudinaryURL, width, opt_height) {
    return cloudinaryResizeImage(cloudinaryImageFromURL(cloudinaryURL), width, opt_height);
}

export function cloudinarySrcSet(cloudinaryURL, breakpointWidths) {
    return Object.values(breakpointWidths).map(width =>
        `${cloudinaryResizeURL(cloudinaryURL, width)} ${width}w`
    ).join(", ");
}


// WEBPACK FOOTER //
// ./src/util/cloudinaryImageUtil.js